<mat-dialog-content class="mat-typography">
  <p *ngIf="data.subtitle" class="text-center">
    <strong>{{ data.subtitle }}</strong>
  </p>
  <p>{{ data.content }}</p>
  <p *ngIf="data.phone" class="text-center">
    {{ data.phone | phoneNumber }}
  </p>

  <ul>
    <li *ngFor="let option of data.options">
      {{ option }}
    </li>
  </ul>
</mat-dialog-content>

<mat-dialog-actions align="center">
  <button
    mat-button
    mat-raised-button
    [color]="data.buttonColor"
    [mat-dialog-close]="true"
  >
    {{ data.acceptText }}
  </button>
</mat-dialog-actions>
